// Game parameter constants - prevents typos
// All string parameters used in the game

export const POWERUP_TYPES = {
  RAPID: 'rapid',
  TRIPLE: 'triple',
  SHIELD: 'shield',
  LIFE: 'life',
  AUTO_AIM: 'autoAim',
  MAGNET: 'magnet',
  SLOW_MOTION: 'slowMotion'
};

export const PARTICLE_TYPES = {
  NORMAL: 'normal',
  EXPLOSION: 'explosion',
  LEVEL: 'level',
  HYPERSPEED: 'hyperspeed',
  TRIPLE: 'triple',
  SHIELD: 'shield',
  LIFE: 'life',
  AUTO_AIM: 'autoAim',
  MAGNET: 'magnet',
  SLOW_MOTION: 'slowMotion',
  BOSS: 'boss',
  BOSS_KILL: 'bossKill'
};

export const OBSTACLE_TYPES = {
  ASTEROID: 'asteroid',
  COMET: 'comet',
  FAST_ENEMY: 'fastEnemy',
  BIG_ENEMY: 'bigEnemy'
};

export const PLAYER_STATES = {
  NORMAL: 'normal',
  HYPERSPEED: 'hyperspeed',
  WALLHACK: 'wallhack'
};


